module.exports = __webpack_public_path__ + "img/dach_2.7a7cc988.jpg";